import { z } from 'zod'

export const estimateShippingFormSchema = z.object({
  region_id: z.string(),
  region: z.string(),
  postcode: z.string(),
  shipping_methods: z.string(),
  country_code: z.string().trim().min(1, { message: 'This is require field.' }),
})

export type TEstimateShippingFormSchema = z.infer<typeof estimateShippingFormSchema>
